import React from 'react';

const ICON = `${process.env.PUBLIC_URL}/icon.svg`;

// The app icon on its own. Decorative next to the wordmark, so alt is empty there.
export const LogoMark = ({ size = 32, alt = 'light speed', style }) => (
    <img
        src={ICON}
        width={size}
        height={size}
        alt={alt}
        className="ls-logo-mark"
        style={{ borderRadius: size * 0.225, ...style }}
        draggable="false"
    />
);

// Icon + wordmark. The wordmark takes the surrounding text colour, so it works on light and dark.
const Logo = ({ size = 28, textSize, style }) => (
    <span className="ls-logo" style={style}>
        <LogoMark size={size} alt="" />
        <span className="ls-logo-word" style={{ fontSize: textSize || Math.round(size * 0.68) }}>light speed</span>
    </span>
);

export default Logo;
